import { Link } from 'react-router-dom';

interface CtaBannerProps {
  title: React.ReactNode;
  lede: React.ReactNode;
  primaryLabel: string;
}

/** Dark end-of-page CTA band for product pages; sends to the lead form. */
export function CtaBanner({ title, lede, primaryLabel }: CtaBannerProps): React.JSX.Element {
  return (
    <section>
      <div className="container">
        <div className="cta-banner reveal">
          <div className="blob blob-blue" style={{ width: 520, height: 520, top: -160, right: '-8%' }} />
          <div className="blob blob-violet" style={{ width: 420, height: 420, bottom: -180, left: '-6%' }} />
          <h2 className="h2">{title}</h2>
          <p className="lede">{lede}</p>
          <div className="hero-ctas">
            <Link to="/#contact" className="btn btn-primary btn-lg">
              {primaryLabel} <span className="arrow">→</span>
            </Link>
            <a href="mailto:contact@inafana.com" className="btn btn-ghost btn-lg">
              Email us instead
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}
